import { FC, useCallback, useEffect, useState } from 'react'
import { Tooltip, TooltipProps } from 'antd'
import classes from './index.module.css'
import cn from 'classnames'

type TooltipWrapperProps = TooltipProps

const TooltipWrapper: FC<TooltipWrapperProps> = ({
  children,
  className,
  overlayClassName,
  color = 'var(--color-surface)',
  open: openProp,
  onOpenChange,
  getPopupContainer,
  ...props
}) => {
  const [open, setOpen] = useState(false)
  const isOpen = openProp ?? open

  const handleOpenChange = useCallback(
    (next: boolean) => {
      setOpen(next)
      onOpenChange?.(next)
    },
    [onOpenChange],
  )

  useEffect(() => {
    if (!isOpen) return

    const hide = () => handleOpenChange(false)

    document.addEventListener('scroll', hide, true)
    return () => document.removeEventListener('scroll', hide, true)
  }, [isOpen, handleOpenChange])

  return (
    <Tooltip
      color={color}
      zIndex={1100}
      className={className}
      overlayClassName={cn(classes.overlay, overlayClassName)}
      open={openProp ?? open}
      onOpenChange={handleOpenChange}
      getPopupContainer={getPopupContainer ?? (() => document.body)}
      {...props}
    >
      {children}
    </Tooltip>
  )
}

export default TooltipWrapper
